var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFindRoom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 30,
    viewBox: "0 0 38 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.667 18.667V12.4a1.4 1.4 0 0 0-1.4-1.4H3.333m33.334 7.667V27.6a1.4 1.4 0 0 1-1.4 1.4h-1.534a1.4 1.4 0 0 1-1.4-1.4v-1.533a1.4 1.4 0 0 0-1.4-1.4h-24.2a1.4 1.4 0 0 0-1.4 1.4V27.6a1.4 1.4 0 0 1-1.4 1.4H2.4A1.4 1.4 0 0 1 1 27.6v-8.933m35.667 0H1m0 0V12.4A1.4 1.4 0 0 1 2.4 11h.933m0 0V2.4a1.4 1.4 0 0 1 1.4-1.4h28.2a1.4 1.4 0 0 1 1.4 1.4v8.267",
    stroke: "#2A4686",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.666 10.664v-3.6a1.4 1.4 0 0 1 1.4-1.4h8.2a1.4 1.4 0 0 1 1.4 1.4v3.933M20 10.664v-3.6a1.4 1.4 0 0 1 1.4-1.4h8.2a1.4 1.4 0 0 1 1.4 1.4v3.933",
    stroke: "#2A4686",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFindRoom);
export default __webpack_public_path__ + "static/media/iconFindRoom.09375de7cab2816ccdd045e7be7f581b.svg";
export { ForwardRef as ReactComponent };